<adapt-dialog [maxWidth]="900">
    <h3 adapt-dialog-title>Edit {{inputGroupTypeLabel}}</h3>
    <div adapt-dialog-content
         class="h-100">
        <div class="d-flex flex-column flex-lg-row">
            <div *ngIf="articleId"
                 [adaptCollapsible]="articleId"
                 class="left-column d-block pe-3 me-lg-4 mb-4 mb-lg-0">
                <adapt-styled-implementation-kit [articleId]="articleId"
                                                 contentStyle="embedded"></adapt-styled-implementation-kit>
            </div>

            <div class="d-flex flex-column mt-4 mt-lg-0 right-column"
                 data-tour="input-group-name-description">
                <label class="mt-3">{{inputGroupTypeLabel}}</label>
                <dx-text-box [(value)]="inputGroup.name"
                             [maxLength]="60"
                             [adaptValidateEntity]="inputGroup"
                             adaptValidateEntityProperty="name"></dx-text-box>

                <label class="mt-3">Description</label>
                <adapt-html-editor [(contents)]="inputGroup.description"
                                   [minHeight]="300"
                                   (isValidChange)="isEditorValid = $event"
                                   forceSize="compact"></adapt-html-editor>
            </div>
        </div>
    </div>
    <div adapt-dialog-footer
         class="d-flex w-100">
        <button adaptButton="delete"
                *ngIf="!isNew"
                data-tour="delete-input-group"
                [adaptBlockingClick]="deleteInputGroup"></button>
        <adapt-standard-dialog-buttons [saveIsDisabled]="inputGroup.entityAspect.hasValidationErrors || !isEditorValid"
                                       [saveBlockingClick]="saveAndClose"
                                       (cancelClick)="cancel()"
                                       cancelText="Cancel">
        </adapt-standard-dialog-buttons>
    </div>
</adapt-dialog>
